export const

  CHANGE_FORM = 'CHANGE_FORM',

  POST_FORM = 'POST_FORM',
  POST_FORM_CANCELLED = 'POST_FORM_CANCELLED',
  POST_FORM_RESOLVED = 'POST_FORM_RESOLVED',
  POST_FORM_REJECTED = 'POST_FORM_REJECTED',

  FETCH_IP = 'FETCH_IP',
  FETCH_IP_CANCELLED = 'FETCH_IP_CANCELLED',
  FETCH_IP_RESOLVED = 'FETCH_IP_RESOLVED',
  FETCH_IP_REJECTED = 'FETCH_IP_REJECTED';



// WEBPACK FOOTER //
// ./src/app/constants.js